
  import {
    defineComponent,
    ref,
    computed
  } from "vue";
  export default defineComponent({
    setup() {
      const htmlString = ref<string>();
      const visible = ref<boolean>(false);
      const timer = ref<number>(0);
      const icontype =  ref<string>();
      const show: (html: any, icon: any) => void = (html: any, icon: any) => {
        icontype.value = icon || "1"
        htmlString.value = html;
        visible.value = true;
        window.clearTimeout(parseInt(timer.value.toString()));
        timer.value = window.setTimeout(() => {
          setTimeout(() => {
            visible.value = false;
          }, 500);
        }, 1500);
      }
      const iconSrc = computed(() => {
        let temp = ""
        if(icontype.value === "1"){
          temp = "https://static.soyoung.com/sy-pre/error-1609135800751.png"
        } else if(icontype.value === "2"){
          temp = "https://static.soyoung.com/sy-pre/success-1609135800751.png"
        } else if(icontype.value === "3"){
          temp = "https://static.soyoung.com/sy-pre/warning%20-1609135800751.png"
        }
        return temp
      });
      return {
        show,
        htmlString,
        visible,
        iconSrc
      }
    }
  })
